<template>
    <div class="container">
        <div class="row">
            <div class="col-12 col-sm-6 col-md-4">
                <h4>Templates</h4>
                <button class="btn-sm btn btn-cph-primary-outline"
                        @click="addFreshTemplate">
                    Add new template
                </button>
                <button class="btn btn-sm btn-danger"
                        @click="deleteAllTemplates">
                    Delete all
                </button>
                <button class="btn btn-sm btn-warning"
                        @click="deleteTemporaryTemplates">
                    Delete temporary
                </button>
                <template-list :list="templates"
                               displayKey="description"
                               @select="selectTemplate"
                               @handleDeletion="handleTemplateDeletion">
                </template-list>
            </div>
            <templates-editor class="col-12 col-sm-6 col-md-4"
                              @add="addNewTemplate"
                              @save="saveExistingTemplate"
                              @deleteProperty="handlePropertyDeletion"
                              :mode="mode"
                              :template.sync="selectedTemplate"
                              v-if="selectedTemplate">
            </templates-editor>
            <template-preview class="col-12 col-md-4"
                              :templateStyle="selectedTemplate.style"
                              v-if="selectedTemplate"/>
        </div>
    </div>
</template>

<script type="text/babel">
import { mapGetters, mapActions, mapMutations } from 'vuex';
import TemplateList from './TemplateList';
import TemplatesEditor from './TemplatesEditor';
import TemplatePreview from './TemplatePreview';
import importMixin from '../../../../mixins/importMixin';
export default {
    name: 'Templates',
    data () {
        return {
            selectedTemplate: null,
            mode: ''
        };
    },
    props: {
        passedData: {
            required: false
        }
    },
    components: {
        TemplatesEditor,
        TemplatePreview,
        TemplateList
    },
    mixins: [importMixin],
    computed: {
        ...mapGetters({
            templates :'getTemplates',
            temporaryTemplates: 'getTemporaryTemplates'
        })
    },
    methods: {
        ...mapActions([
            'addTemplateAsync',
            'removeTemplateAsync',
            'updateTemplateAsync',
            'getAllTemplatesAsync',
            'getTemplateJSONAsync',
            'getTemplateByTemplateIdAsync'
        ]),
        ...mapMutations(['addTemplate', 'updateTemplateById']),
        async selectTemplate (template) {
            try {
                let {data} = await this.getTemplateByTemplateIdAsync(template);
                let {data: res} = await this.getTemplateJSONAsync(data[0]);
                this.mode = 'edition';
                this.selectedTemplate = {
                    ...template,
                    style: res[0].style,
                    groups: res[0].groups
                };
            } catch (err) {
                throw new Error(err);
            }
        },
        addFreshTemplate () {
            this.mode = 'addition';
            this.selectedTemplate = {
                style: {},
                id: this.$utils.shortid.generate(),
                groups: []
            };
        },
        resetSelectedTemplate () {
            this.selectedTemplate = null;
            this.groupHasChanged = false;
            this.mode = '';
        },
        async deleteAllTemplates () {
            try {
                await this.$utils.resolvePromises(
                    this.templates.map(template => this.handleTemplateDeletion(template, true))
                );
                await this.getAllTemplatesAsync();
            } catch (err) {
                this.$store.commit('addAlert', {
                    title: 'Failed ',
                    type: 'danger',
                    body: 'delete all templates'
                });
                throw new Error(err);
            }
        },
        async deleteTemporaryTemplates () {
            try {
                await this.$utils.resolvePromises(this.temporaryTemplates.map(
                    template => this.handleTemplateDeletion(template, true))
                );
                await this.getAllTemplatesAsync();
            } catch (err) {
                this.$store.commit('addAlert', {
                    title: 'Failed ',
                    type: 'danger',
                    body: 'delete all templates'
                });
                throw new Error(err);
            }
        },
        async addNewTemplate () {
            await this.addTemplateAsync(this.selectedTemplate);
            this.getAllTemplatesAsync();
            this.resetSelectedTemplate();
        },
        saveExistingTemplate () {
            this.updateTemplateAsync(this.selectedTemplate);
            this.getAllTemplatesAsync();
        },
        async handleTemplateDeletion (template, noFetch) {
            try {
                let { data } = await this.removeTemplateAsync(template);
                this.selectedTemplate = null;
                if(!noFetch) {
                    this.getAllTemplatesAsync();
                }
                return {data};
            } catch (err) {
                throw new Error(err);
            }
            
        },
        handlePropertyDeletion (propertyName) {
            this.$delete(this.selectedTemplate.style, propertyName);
        }
    },
    created () {
        this.getAllTemplatesAsync();
        if(this.passedData) {
            this.selectTemplate(this.passedData);
        }
    }
};

</script>
